<template>
  <button
    type="button"
    class="
      absolute left-auto right-0 mt-[-0.9rem] h-[1.8rem] w-10 shrink-0 rotate-0
      cursor-pointer
      max-lg:top-14
      lg:relative lg:right-auto lg:ml-8 lg:mr-3
      print:hidden
    "
    @keydown.enter="navigation.getActiveLevel !== 0 ? navigation.reset() : ''"
    @click="toggleNav()"
    @focusin="navigation.setNetworkNavOpenState(false)"
  >
    <span
      class="
        absolute top-0 block h-[2px] w-full origin-left bg-red-500 opacity-100
        transition-all duration-250 ease-in-out
      "
      :class="[
        navigation.getOpen ? 'left-1.5 rotate-45' : 'left-0 rotate-0',
      ]"
    />
    <span
      class="
        absolute left-0 top-[0.8rem] block h-[2px] w-full origin-left rotate-0
        bg-red-500 transition-all
      "
      :class="[
        navigation.getOpen
          ? 'opacity-0 duration-200 ease-out'
          : 'opacity-100 duration-300 ease-in',
      ]"
    />
    <span
      class="
        absolute block h-[2px] w-full origin-left bg-red-500 opacity-100
        transition-all duration-250 ease-in-out
      "
      :class="[
        navigation.getOpen
          ? 'left-1.5 top-[1.7rem] -rotate-45'
          : 'left-0 top-[1.6rem] rotate-0',
      ]"
    />
  </button>
</template>

<script lang="ts" setup>
const navigation = useNavigationStore()

const toggleNav = () => {
  const timeout = navigation.getNetworkNavOpen ? 150 : 0

  navigation.setNetworkNavOpenState(false)
  setTimeout(() => {
    navigation.toggle()
  }, timeout)
}
</script>
